import React from 'react';
import { Button } from '../components/Form';
import { useNavigate } from 'react-router-dom';

function WithoutData({url='/', text='Volvel al Inicio'}) {
  const navigate = useNavigate();
  return (
    <div className="w-full flex-colo bg-dry text-center">
      <img
        src="/images/404.svg"
        alt="404"
        className="w-full max-h-96 object-contain"
      />
      <h1 className="text-4xl font-bold mt-10">No existen Registros</h1>
      <p className="text-lg text-textGray my-3">
        No existen Registros
      </p>
      <div className="w-48">
        <Button
          label={text}
          Icon={null}
          onClick={() => navigate(url)}
        />
      </div>
    </div>
  );
}

export default WithoutData;